/**
 * 加载状态组件
 * @author wangdi
 */

/*===============================================================================================@

 ### 功能

 #### $Loading.coverShow
 #### $Loading.coverHide
 param1: string | 显示字符串
 > 可以多次调用，参数使用不同的字符串会构成纵向提示列表， hide方法如果传入相同的字符串，会优先隐藏提示为此字符串的文本。（这个功能不完善，需要所有的show、hide字符串一一对应且无重复才能正确运作）
 > 时间过长默认会有随机的超时提醒，10秒后会自动消失

 #### $Loading.pageShow
 #### $Loading.pageHide
 param1: string | 显示字符串

 #### $Loading.insetShow
 #### $Loading.insetHide
 param1: container | 插入的容器元素，没有的话则会放置在Body末尾

 #### $Loading.moonShow
 #### $Loading.moonHide
 param1: container | 相对容器元素居中遮罩显示
 > 会相对容器进行居中显示
 > 转圈圈

 @==============================================================================================*/


// 外部依赖
import $wd from '../../utils';

// 添加CSS样式
require("./assets/css/element-loading.scss");
let coverLoadingTemplate = require("./assets/views/element-loading-fullscreen.html");

/**
 * 读取模板
 */
function LoadTemplate(mark) {
    let template = LoadTemplate.useSelector ? document.querySelector('#templateContainer [data-template="' + mark + '"]')
        || document.querySelector('#templateContainer [template="' + mark + '"]')
        || document.querySelector('[data-template="' + mark + '"]')
        || document.querySelector('[template="' + mark + '"]') : null;
    return template ? function () {
            return template.children[0] && template.children[0].cloneNode(true);
        }() : function () {
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = LoadTemplate.resource && LoadTemplate.resource[mark];
            return tempDiv.children[0];
        }();
}
LoadTemplate.useSelector = false;
LoadTemplate.resource = {
    coverLoading: coverLoadingTemplate,
    pageLoading: coverLoadingTemplate,
    insetLoading: "<div id=\"insetLoadingBox\" class=\"load-more loading-more\" style=\"display:none;\"><span class=\"loading-ring\"></span>努力加载中...</div>"
};

// 屏幕高度
let $ScreenHeight = document.documentElement.clientHeight || screen.height;

/**
 * 努力加载中显示 > 嵌入到其他元素中
 * 覆盖页面的Loading显示
 * <p>
 *      <br/>示例：
 *      <div><img width="200" src="../img/wdLoadingInset.png"/></div>
 * </p>
 * @param {Element} placeElem 目标容器
 * @memberof module:Loading
 * @example $Loading.insetShow(container);
 */
function insetShow(placeElem) {
    if (!(placeElem && placeElem.appendChild)) return;
    if (placeElem.querySelector('#insetLoadingBox')) return;
    let loadingElem = LoadTemplate('insetLoading');
    loadingElem.style.display = '';
    placeElem.appendChild(loadingElem);
}
/**
 * 努力加载中隐藏
 * @param {Element} placeElem 目标容器
 * @memberof module:Loading
 * @example $Loading.insetShow(container);
 */
function insetHide(placeElem) {
    if (!(placeElem && placeElem.appendChild)) return;
    let loadingElem = placeElem.querySelector('#insetLoadingBox');
    if (loadingElem) loadingElem.parentElement.removeChild(loadingElem);
}

/**
 * 页面替换型加载中显示
 * <p>
 *      <br/>示例：
 *      <div><img width="200" src="../img/wdLoadingPage.png"/></div>
 * </p>
 * @memberof module:Loading
 * @example $Loading.pageShow();
 */
function pageShow() {
    let baseLoadingPage = document.querySelector('#basePageLoading');
    // 不存在Loading页面 > 初始化
    if (!baseLoadingPage) {
        baseLoadingPage = LoadTemplate('pageLoading');
        document.body.appendChild(baseLoadingPage);
    }
    // 隐藏现有视图
    if (document.querySelector('.viewport')) {
        document.querySelector('.viewport').style.display = "none";
    }
    // 高度重置
    baseLoadingPage.querySelector('.page-loading-logo').style.marginTop = ($ScreenHeight / 2 - 100) + 'px';
    baseLoadingPage.style.display = '';
}
/**
 * 页面替换型加载中隐藏
 * @memberof module:Loading
 * @example $Loading.pageHide();
 */
function pageHide() {
    let baseLoadingPage = document.querySelector('#basePageLoading');
    baseLoadingPage.style.display = 'none';

    // 显示现有视图
    if (document.querySelector('.viewport')) {
        document.querySelector('.viewport').style.display = "";
    }
}

let CoverLoading = {
    // 配置信息
    showCount: 0,
    showState: false,
    textQueue: [],
    minTime: 500,
    maxTime: 16000,
    maxTipNum: 5,
    randomTips: {
        normal: ['加载中，请稍候...', '正在努力加载中...', '稍等片刻，加载中...'],
        hurry: ['网速较慢，请耐心等待...'],
        soLong: ['也许等待的时间可以喝杯茶了...'],
        die: ['可能网络异常，不等了，在下先撤了']
    },
    loadingQueue: [
        /*{
         startTime:null,
         tipText:null,
         curTipText:null,
         },*/
    ],
    intervalHandle: null,
    textElem: null,
    // 视觉展示时间控制
    visualStartTime: null,
    // 载入视图元素
    loadingElem: null,
    scheduler: null,
    /**
     * 覆盖页面的Loading显示
     * <p>
     *      <br/>示例：
     *      <div><img width="200" src="../img/wdLoadingCover.png"/></div>
     * </p>
     * @param {String} tipText 提示文本
     * @param {number|boolean} dynamic 提示文本
     * @memberof module:Loading
     * @example $Loading.coverShow('购物车加载中');
     */
    coverShow: function (tipText, dynamic) {
        // 第一次 > 初始化
        if (this.loadingElem == null) {
            this.loadingElem = LoadTemplate('coverLoading');
            this.loadingElem.style.display = "none";
            document.body.appendChild(this.loadingElem);
        }
        // 基础元素
        let loadingElem = this.loadingElem;
        this.textElem = loadingElem.querySelector('.el-loading-text');
        // 使用定时器管理 Loading整体状态
        let me = this;
        if (me.scheduler == null) {
            me.scheduler = setInterval(function () {
                // 控制显示隐藏
                if (me.showCount >= 1) {
                    // 进行显示操作
                    loadingElem.style.display = "";
                    setTimeout(function () {
                        $wd(loadingElem).addClass("active");
                    },1)
                } else {
                    // 进行隐藏操作
                    $wd(loadingElem).removeClass("active");
                    setTimeout(function () {
                        loadingElem.style.display = "none";
                    },300);
                    clearInterval(me.scheduler);
                    me.scheduler = null;
                }
                // // 提示文本动态调整
                // me.refreshLoadingQueue();
            }, this.minTime);
        }
        // 计数器加一
        this.showCount++;
        let loadingInfo = {
            startTime: new Date().getTime(),
            tipText: tipText ? tipText : null,
            curTipText: tipText ? tipText : this.getRandomTip(1),
            dynamic: dynamic || 0
        };
        this.loadingQueue.push(loadingInfo);
        this.refreshLoadingQueue();
    },
    /**
     * 覆盖页面的Loading隐藏
     * @param {String=} tipText 提示文本，如果hide方法也获得了相同的提示字符串则会隐藏在列表中（多次触发coverLoading）对应字符串的提示
     * @memberof module:Loading
     * @example $Loading.coverHide('购物车加载中');
     */
    coverHide: function (tipText) {
        // 移除一个载入信息
        let filterArray = this.loadingQueue.filter(e => e != this.loadingQueue.find(e => e.tipText == tipText));
        if (filterArray.length == this.loadingQueue.length) {
            console.warn("Warning : $Loading.coverHide tipText match failed , another loading item as a replacement has been removed");
        } else if (this.showCount > 0) {
            this.showCount--;
            this.loadingQueue = filterArray;
        }
        this.refreshLoadingQueue();
    },
    /**
     * 获得加载提示文本
     * @param type 文本类型
     * @returns {*}
     */
    getRandomTip: function (type) {
        switch (type) {
            case 1:
                return this.randomTips.normal[parseInt(Math.random() * this.randomTips.normal.length)];
                break;
            case 2:
                return this.randomTips.hurry[parseInt(Math.random() * this.randomTips.hurry.length)];
                break;
            case 3:
                return this.randomTips.soLong[parseInt(Math.random() * this.randomTips.soLong.length)];
                break;
            case 4:
                return this.randomTips.die[parseInt(Math.random() * this.randomTips.die.length)];
                break;
            default:
                break;
        }
    },
    refreshLoadingQueue: function () {
        this.textQueue.length = 0;
        if (this.loadingQueue <= 0) return;
        for (let i = 0; i < this.loadingQueue.length; i++) {
            let loadingInfo = this.loadingQueue[i];
            if (loadingInfo.dynamic) {
                if (new Date().getTime() - loadingInfo.startTime > 3000 + loadingInfo.dynamic) {
                    loadingInfo.curTipText = this.getRandomTip(2);
                }
                if (new Date().getTime() - loadingInfo.startTime > 8000 + loadingInfo.dynamic) {
                    loadingInfo.curTipText = this.getRandomTip(3);
                }
                if (new Date().getTime() - loadingInfo.startTime > this.maxTime - 2000 + loadingInfo.dynamic) {
                    loadingInfo.curTipText = this.getRandomTip(4);
                }
                if (new Date().getTime() - loadingInfo.startTime > this.maxTime + loadingInfo.dynamic) {
                    this.coverHide(loadingInfo.tipText);
                }
            }
            this.textQueue.push(loadingInfo.curTipText);
        }
        this.textElem.innerHTML = this.textQueue.filter((value, index) => {
            return this.textQueue.length - index <= this.maxTipNum
        }).join('\n');
    }
};

// 导出对象
let $Loading = {
    start: pageShow,
    end: pageHide,
    pageShow: pageShow,
    pageHide: pageHide,
    insetShow: insetShow,
    insetHide: insetHide,
    coverShow: function () {
        CoverLoading.coverShow.apply(CoverLoading, arguments);
    },
    coverHide: function () {
        CoverLoading.coverHide.apply(CoverLoading, arguments);
    },
    moonShow: function () {
        CoverLoading.coverShow.apply(CoverLoading, arguments);
    },
    moonHide: function () {
        CoverLoading.coverHide.apply(CoverLoading, arguments);
    }
};

// 接口函数集中调度
$wd.invokeProxy($Loading, function () {
    return true;
});

// module.exports = $Loading;
export default $Loading;